<template>
  <details v-if="items.length" class="ai-evidence">
    <summary>判断依据 · {{ items.length }} 处</summary>
    <div v-for="item in items" :key="item.id" class="ai-source">
      <b>{{ item.label }}</b>
      <p>{{ item.text }}</p>
    </div>
  </details>
</template>
<script>
export default {
  props: {
    refs: { type: Array, default: () => [] },
    sources: { type: Array, default: () => [] }
  },
  computed: {
    items() {
      return this.sources.filter(item => this.refs.indexOf(item.id) >= 0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ai-evidence.vue